import { render, staticRenderFns } from "./active-account.vue?vue&type=template&id=038e34a7&"
import script from "./active-account.vue?vue&type=script&lang=js&"
export * from "./active-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports